import { render, staticRenderFns } from "./RolePermission.vue?vue&type=template&id=4f4004f0&scoped=true&"
import script from "./RolePermission.vue?vue&type=script&lang=js&"
export * from "./RolePermission.vue?vue&type=script&lang=js&"
import style0 from "./RolePermission.vue?vue&type=style&index=0&id=4f4004f0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f4004f0",
  null
  
)

export default component.exports